import React, {PropTypes as T} from 'react';
import ReactModal from 'react-modal';
import noScroll from '../../../utils/noscroll';

export ModalHeader from './header';
export ModalFooter from './footer';
export ModalContent from './content';

export default React.createClass({
  displayName: 'Modal',

  propTypes: {
    dataComponent: T.string,
    isOpen: T.bool,
    shouldCloseOnOverlayClick: T.bool,
    onClose: T.func,
    onAfterOpenModal: T.func,
    children: T.node,
    width: T.oneOfType([T.number, T.bool]),
    styles: T.shape({
      overlayStyles: T.object,
      contentStyles: T.object
    }),
    labelledBy: T.string,
    describedBy: T.string,
    className: T.string,
    appElement: T.string
  },

  getDefaultProps () {
    return {
      onClose: Function.prototype,
      onAfterOpenModal: Function.prototype
    };
  },

  // styles for the react modal, the mfol styles are found in the _modal.scss file
  // See MNXWEB-3645 for zIndex. Decided to make it 99 because on BA page z-index
  // of price type list items is set dynamically (from right to left, starting from the
  // bottom right item). If there are 15 items, z-index of the upper left item will be 15.
  modalStyles (overlayStyles = {}, contentStyles = {}) {
    return {
      overlay : {
        position        : overlayStyles.position        || 'fixed',
        top             : overlayStyles.top             || 0,
        left            : overlayStyles.left            || 0,
        right           : overlayStyles.right           || 0,
        bottom          : overlayStyles.bottom          || 0,
        backgroundColor : overlayStyles.backgroundColor || 'rgba(0, 0, 0, 0.75)',
        zIndex          : overlayStyles.zIndex          || 99,
        display         : contentStyles.display         || 'flex',
        alignItems      : contentStyles.alignItems      || 'center',
        justifyContent  : contentStyles.justifyContent  || 'center'
      },
      content : {
        position                : contentStyles.position                || 'static',
        top                     : contentStyles.top                     || 'auto',
        left                    : contentStyles.left                    || 'auto',
        right                   : contentStyles.right                   || 'auto',
        bottom                  : contentStyles.bottom                  || 'auto',
        border                  : contentStyles.border                  || '0',
        background              : contentStyles.background              || 'transparent',
        overflow                : contentStyles.overflow                || 'visible',
        WebkitOverflowScrolling : contentStyles.WebkitOverflowScrolling || 'touch',
        borderRadius            : contentStyles.borderRadius            || '0',
        outline                 : contentStyles.outline                 || 'none',
        padding                 : contentStyles.padding                 || '0'
      }
    };
  },

  beforeClose () {
    setTimeout(noScroll.off, 310);
    this.props.onClose();
  },

  afterOpen () {
    noScroll.on();
    this.props.onAfterOpenModal();
  },

  componentWillMount () {
    const appElement =  document.querySelector(this.props.appElement);
    if (appElement) {
      ReactModal.setAppElement(appElement);
    }
  },

  render () {
    const {overlayStyles, contentStyles} = this.props.styles || {};
    return <ReactModal
      ref="modal"
      role="alertdialog"
      aria-modal="true"
      isOpen={this.props.isOpen}
      onRequestClose={this.beforeClose}
      onAfterOpen={this.afterOpen}
      closeTimeoutMS={300}
      shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
      aria={{
        labelledby: this.props.labelledBy,
        describedby: this.props.describedBy
      }}
      style={this.modalStyles(overlayStyles, contentStyles)}>
      <div
        style={this.props.width ? { width: this.props.width } : {}}
        className={`modal__container ${this.props.className || ''}`}
        data-component={this.props.dataComponent}>
        {this.props.children}
      </div>
    </ReactModal>;
  }
});



// WEBPACK FOOTER //
// ./frontend/react/components/common/modal/index.js